var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628601 6.02966C0.628601 5.81696 0.713095 5.61298 0.863496 5.46258C1.0139 5.31218 1.21788 5.22768 1.43058 5.22768L12.3268 5.22768L9.4183 2.31917C9.27664 2.16714 9.19952 1.96606 9.20319 1.75829C9.20685 1.55052 9.29102 1.35229 9.43795 1.20535C9.58489 1.05842 9.78313 0.97425 9.99089 0.970584C10.1987 0.966918 10.3997 1.04404 10.5518 1.1857L14.829 5.46293C14.9792 5.6133 15.0635 5.81714 15.0635 6.02966C15.0635 6.24219 14.9792 6.44602 14.829 6.59639L10.5518 10.8736C10.3997 11.0153 10.1987 11.0924 9.99089 11.0887C9.78312 11.0851 9.58489 11.0009 9.43795 10.854C9.29102 10.707 9.20685 10.5088 9.20319 10.301C9.19952 10.0933 9.27664 9.89218 9.4183 9.74016L12.3268 6.83164L1.43058 6.83164C1.21788 6.83164 1.0139 6.74715 0.863496 6.59675C0.713095 6.44635 0.628601 6.24236 0.628601 6.02966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.cfe2950df9d46084bd40f8bc908bc823.svg";
export { ForwardRef as ReactComponent };